import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-16ofmh8-0' })`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const Header = styled.div.withConfig({ componentId: 'sc-16ofmh8-1' })`
    margin-bottom: ${size(2)};
`;

export const HeaderImageWrapper = styled.div.withConfig({ componentId: 'sc-16ofmh8-2' })`
    position: relative;
    height: 0;
    padding-bottom: 66.66666667%;
    background-color: var(--c-contrast-bg);
`;

export const HeaderImage = styled.img.withConfig({ componentId: 'sc-16ofmh8-3' })`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const BodyHeader = styled.div.withConfig({ componentId: 'sc-16ofmh8-4' })`
    display: flex;
    align-items: flex-start;
`;

export const BodyHeaderContent = styled.div.withConfig({ componentId: 'sc-16ofmh8-5' })`
    flex: 1 1 auto;
`;

export const LogoWrapper = styled.div.withConfig({ componentId: 'sc-16ofmh8-6' })`
    flex-shrink: 0;
`;

export const Heading = styled.div.withConfig({ componentId: 'sc-16ofmh8-7' })`
    font-size: ${(props) => props.theme.font.size.large};
    font-weight: var(--font-weight-bold);

    ${(props) => props.theme.breakpoint.LtSm} {
        font-size: ${(props) => props.theme.font.size.regular};
    }
`;

export const SubHeading = styled.div.withConfig({ componentId: 'sc-16ofmh8-8' })`
    font-weight: var(--font-weight-medium);

    ${(props) => props.theme.breakpoint.LtSm} {
        font-size: ${(props) => props.theme.font.size.small};
    }
`;

export const Body = styled.div.withConfig({ componentId: 'sc-16ofmh8-9' })`
    margin-top: ${size(1)};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    ${(props) => props.theme.breakpoint.LtSm} {
        font-size: ${(props) => props.theme.font.size.small};
    }
`;

export const Footer = styled.div.withConfig({ componentId: 'sc-16ofmh8-10' })`
    margin-top: auto;
    padding-top: ${size(1)};
    font-size: ${(props) => props.theme.font.size.small};
`;
